import { styled } from '../../../../utils/styled';
import { propStyles } from '../../../../utils/propStyles';

const StyledComponent = styled<any, any>(
    'div',
    'documentCard',
    'documentsGrid'
)`
    ${propStyles};
    box-shadow: 2px 2px 0 rgb(0 0 0 / 10%);
    border-style: solid;
    border-color: #dee2e6;
    border-radius: 3px;
    border-width: 1px;
    flex-direction: column;
    background-color: #fff;
    margin: 0 0 16px 0;
    display: flex;
`;

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Document/DocumentsGrid/StyledComponents/DocumentCard.tsx